import { Box } from "@chakra-ui/react";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Axios from "../../utils/axiosService";
import ButtonBack from "../ButtonBack";

function Header() {
  const { search } = useLocation();
  const [appData, setAppData] = useState({});

  const logoutHandler = () => {
    localStorage.removeItem("login");
    localStorage.removeItem("region_user");
    localStorage.removeItem("role_user");
    localStorage.removeItem("username");
    localStorage.removeItem("id_user");
    localStorage.removeItem("id_user_parastay")
    localStorage.removeItem("paraspaceToken");
    localStorage.removeItem("user_data");
    window.location.assign("/auth/login");
  };

  useEffect(() => {
    const query = new URLSearchParams(search);
    const id = query.get("id") || localStorage.getItem("appId");

    Axios({
      method: "GET",
      url: `/app/${id}`,
    })
      .then((r) => setAppData(r.data.data.data))
      .catch((errorMsg) => {
        if (errorMsg.response) {
          if (errorMsg.response.status === 401) {
            logoutHandler();
          }
        }
      });
  }, [search]);

  return (
    <div
      className="is-flex is-full-widescreen"
      style={{
        background: "#FFF",
        position: "relative",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        color: "rgba(0, 0, 0, 0.7)",
        fontSize: "20px",
        boxShadow: "0px 1px 21px -1px rgba(0, 0, 0, 0.25)",
        padding: "24px 0",
      }}
    >
      <Box position="absolute" left="6">
        <ButtonBack />
      </Box>
      <div
        style={{
          color: appData.color,
        }}
      >
        <i className={appData.icon}></i>
      </div>
      <h1 className=" has-text-weight-bold">{appData.name}</h1>
    </div>
  );
}

export default Header;
